import LocalStorageService from './localstorageService'
import axios from 'axios'

export const USUARIO_LOGADO = '_usuario_logado' //chave da sessao/cookie que fica armazenada no site

export default class AuthService {

    // Verifica se usuário está autenticado
    static isUsuarioAutenticado() {
        const usuario = LocalStorageService.obterItem(USUARIO_LOGADO)
        return usuario && usuario.token; // agora verificamos o token
    }

    // Remove usuário + token
    static removerUsuarioAutenticado() {
        LocalStorageService.removerItem(USUARIO_LOGADO)
        AuthService.removerToken()
    }

    // Salva usuário + token no localStorage e configura axios
    static logar(usuario) {
        LocalStorageService.adicionarItem(USUARIO_LOGADO, usuario)
        
        // Se houver token JWT, registra no axios (opcional)
        if (usuario.token) {
            AuthService.registrarToken(usuario.token);
        }
    }

    // Recupera usuário armazenado
    static obterUsuarioAutenticado() {
        return LocalStorageService.obterItem(USUARIO_LOGADO)
    }

    // Restaura a sessão (ex: após refresh da página)
    static refreshSession() {
        const usuario = AuthService.obterUsuarioAutenticado()
        if (usuario && usuario.token) {
            AuthService.registrarToken(usuario.token)
        }
        return usuario
    }

    // Configura o token JWT no axios
    static registrarToken(token) {
        if (token) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
        }
    }

    // Remove o token do axios
    static removerToken() {
        delete axios.defaults.headers.common['Authorization']
    }
}